module.exports = __webpack_public_path__ + "static/media/apple.dfd1590e.svg";